'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _immutable = require('immutable');

var _Button = require('./blocks/Button');

var _Button2 = _interopRequireDefault(_Button);

var _TextBlock = require('./blocks/TextBlock');

var _TextBlock2 = _interopRequireDefault(_TextBlock);

var _cf_ = require('./images/cf_20.png');

var _cf_2 = _interopRequireDefault(_cf_);

var _RenderHelper = require('./RenderHelper');

var _cf_rtl_ = require('./images/cf_rtl_20.png');

var _cf_rtl_2 = _interopRequireDefault(_cf_rtl_);

var _RenderSummaryResults = require('./RenderSummaryResults');

var _RenderSummaryResults2 = _interopRequireDefault(_RenderSummaryResults);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _require = require('draft-js'),
    Editor = _require.Editor,
    EditorState = _require.EditorState,
    ContentState = _require.ContentState,
    convertToRaw = _require.convertToRaw,
    convertFromRaw = _require.convertFromRaw,
    Entity = _require.Entity,
    Modifier = _require.Modifier,
    CompositeDecorator = _require.CompositeDecorator;

var coursefinderImgStyle = {
  position: 'relative',
  display: 'block',
  width: '70%',
  margin: '0 auto'
};

var quizPercentStyle = {
  position: 'absolute',
  textAlign: 'center',
  display: 'block',
  width: '100px',
  right: '98px',
  top: '120px'
};

var wseContentStyle = {
  padding: '5%'
};

var scoreContainerStyle = {
  marginTop: '20px'
};

var mainContainerStyle = {
  maxWidth: '60%'
};

var mainCfContainerStyle = {
  maxWidth: '100%'
};

var resultsContainerStyle = {
  clear: 'both',
  paddingTop: 0
};

var resultsContainerActionsStyle = {
  paddingtop: '0'
};

var RenderEmail = function (_Component) {
  _inherits(RenderEmail, _Component);

  function RenderEmail() {
    _classCallCheck(this, RenderEmail);

    return _possibleConstructorReturn(this, (RenderEmail.__proto__ || Object.getPrototypeOf(RenderEmail)).apply(this, arguments));
  }

  _createClass(RenderEmail, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (!this.props.preview && this.props.transformedLead && this.props.transformedLead.name) {
        var domNode = _reactDom2.default.findDOMNode(this);
        var leadName = this.props.transformedLead.name.replace(/\W+/g, " ");
        domNode.innerHTML = domNode.innerHTML.replace(/{NAME}/gi, leadName);
      }
    }
  }, {
    key: 'mountMainText',
    value: function mountMainText(iText) {
      if (!_immutable.List.isList(iText)) return null;
      return iText.map(function (text, i) {
        return _react2.default.createElement(_TextBlock2.default, { key: 'RenderEmail_mainText_' + i, id: text.get('id'), data: text });
      });
    }
  }, {
    key: 'mountScoreText',
    value: function mountScoreText(scoreSubTitle, scoreBody) {
      return _react2.default.createElement(
        'div',
        { style: scoreContainerStyle },
        _react2.default.createElement(_TextBlock2.default, { id: scoreSubTitle.get('id'), data: scoreSubTitle }),
        _react2.default.createElement(_TextBlock2.default, { id: scoreBody.get('id'), data: scoreBody })
      );
    }
  }, {
    key: 'mountMainButtons',
    value: function mountMainButtons(iButton) {
      var _this2 = this;

      if (!_immutable.List.isList(iButton)) return null;
      return iButton.map(function (button) {
        if (_this2.props.previewQuizScreen || !!button.handleNext && !button.get('hyperlink')) {
          return _react2.default.createElement(_Button2.default, {
            key: button.get('id') || null,
            data: button,
            primary: true,
            previewQuizScreen: _this2.props.previewQuizScreen
          });
        } else {
          return _react2.default.createElement(
            'div',
            { className: 'wsequiz_button wsequiz_button-primary', key: button.get('id') },
            _react2.default.createElement(
              'a',
              { href: button.get('hyperlink') },
              _react2.default.createElement(
                'button',
                { tabIndex: '0', type: 'button' },
                _react2.default.createElement(
                  'div',
                  null,
                  _react2.default.createElement(
                    'span',
                    null,
                    button.get('buttonText')
                  )
                )
              )
            )
          );
        }
      });
    }
  }, {
    key: 'mountScoreButtons',
    value: function mountScoreButtons(scoreButton) {
      var _this3 = this;

      if (!_immutable.List.isList(scoreButton)) return null;
      return scoreButton.map(function (button) {
        if (_this3.props.previewQuizScreen || !!button.handleNext && !button.get('hyperlink')) {
          return _react2.default.createElement(_Button2.default, {
            key: button.get('id') || null,
            data: button,
            primary: true,
            previewQuizScreen: _this3.props.previewQuizScreen
          });
        } else {
          return _react2.default.createElement(
            'div',
            { className: 'wsequiz_button wsequiz_button-primary', key: button.get('id') },
            _react2.default.createElement(
              'a',
              { href: button.get('hyperlink') },
              _react2.default.createElement(
                'button',
                { tabIndex: '0', type: 'button' },
                _react2.default.createElement(
                  'div',
                  null,
                  _react2.default.createElement(
                    'span',
                    null,
                    button.get('buttonText')
                  )
                )
              )
            )
          );
        }
      });
    }
  }, {
    key: 'getScores',
    value: function getScores() {
      var _props = this.props,
          data = _props.data,
          preview = _props.preview,
          transformedLead = _props.transformedLead,
          quizType = _props.quizType;

      var iScores = data.get('scores');
      var scoreSubTitle = (0, _immutable.Map)();
      var scoreBody = (0, _immutable.Map)();
      var scoreButtons = (0, _immutable.Map)();
      var flatScore = transformedLead && transformedLead.score && transformedLead.score * 100 || 15;
      if (transformedLead && typeof transformedLead.score !== 'undefined' && !transformedLead.score) flatScore = 0;

      if (preview) {
        scoreSubTitle = _immutable.List.isList(iScores) ? iScores.first().get('subHeading') || (0, _immutable.Map)() : (0, _immutable.Map)();
        scoreBody = _immutable.List.isList(iScores) ? iScores.first().get('body') || (0, _immutable.Map)() : (0, _immutable.Map)();
        scoreButtons = _immutable.List.isList(iScores) ? iScores.first().get('buttons') || (0, _immutable.Map)() : (0, _immutable.Map)();
      } else if (!!transformedLead) {
        var scoreMatch = false;
        switch (quizType === 'Quiz') {
          case transformedLead.score * 100 < 34:
            scoreMatch = iScores.find(function (score) {
              return score.get('name') === 'low';
            });
            break;
          case transformedLead.score * 100 < 66:
            scoreMatch = iScores.find(function (score) {
              return score.get('name') === 'mid';
            });
            break;
          default:
            scoreMatch = iScores.find(function (score) {
              return score.get('name') === 'high';
            });
        }
        if (quizType === 'Course Finder') {
          var scoreVal = Math.round(transformedLead.score * 10);
          scoreMatch = iScores.find(function (score) {
            return score.get('name') === 'level' + scoreVal;
          });
        }
        if (scoreMatch) {
          scoreSubTitle = scoreMatch.get('subHeading') || (0, _immutable.Map)();
          scoreBody = scoreMatch.get('body') || (0, _immutable.Map)();
          scoreButtons = scoreMatch.get('buttons') || (0, _immutable.Map)();
        }
      }

      return {
        scoreSubTitle: scoreSubTitle,
        scoreBody: scoreBody,
        scoreButtons: scoreButtons,
        flatScore: flatScore
      };
    }
  }, {
    key: 'renderResults',
    value: function renderResults() {
      var _props2 = this.props,
          data = _props2.data,
          results = _props2.results,
          exampleResults = _props2.exampleResults;

      if (!data.get('showResults')) return null;
      var _data = results && results.length ? results : exampleResults;

      return _react2.default.createElement(_RenderSummaryResults2.default, { data: _data });
    }
  }, {
    key: 'renderQuiz',
    value: function renderQuiz() {
      var _ref = this.props || {},
          data = _ref.data,
          settings = _ref.settings,
          quizType = _ref.quizType,
          className = _ref.className,
          preview = _ref.preview,
          measureRef = _ref.measureRef,
          transformedLead = _ref.transformedLead;

      var _getScores = this.getScores(),
          scoreSubTitle = _getScores.scoreSubTitle,
          scoreBody = _getScores.scoreBody,
          scoreButtons = _getScores.scoreButtons,
          flatScore = _getScores.flatScore;

      var pctRound = Math.round(flatScore * 0.1) * 10;

      var renderResults = function renderResults() {
        var questionCount = data.qs && Object.keys(data.qs).filter(function (ok) {
          var isQuestion = data.qs[ok] && data.qs[ok].type === 'question';
          return isQuestion;
        }).length;
        if (!questionCount || !questionCount.length) return false;
        return _react2.default.createElement(
          'div',
          { className: 'quiz_progress__wrapper' },
          _react2.default.createElement('img', { className: 'quiz_progress', src: 'https://quiz.wsemktapp.com/progress/pct_' + pctRound + '.gif' }),
          _react2.default.createElement(
            'h1',
            { className: 'quiz_progress_heading' },
            Math.round(flatScore),
            '%'
          )
        );
      };
      if (!data.qs || !data.qs.length) mainContainerStyle.maxWidth = '100%';
      return _react2.default.createElement(
        'div',
        { className: className, ref: measureRef },
        _react2.default.createElement(
          'div',
          { style: wseContentStyle, className: 'wsequiz_content' + (preview ? ' preview' : '') },
          _react2.default.createElement(
            'div',
            { style: mainContainerStyle, className: 'quiz_progress__main' },
            this.mountMainText(data.get('texts')),
            this.mountMainButtons(data.get('buttons')),
            this.mountScoreText(scoreSubTitle, scoreBody),
            this.mountScoreButtons(scoreButtons)
          ),
          renderResults(),
          data.get('showResults') && _react2.default.createElement(
            'div',
            { style: resultsContainerStyle },
            this.renderResults(),
            _react2.default.createElement(
              'div',
              { style: resultsContainerActionsStyle },
              this.mountScoreButtons(scoreButtons)
            )
          )
        )
      );
    }
  }, {
    key: 'renderCourseFinder',
    value: function renderCourseFinder() {
      var _props3 = this.props,
          data = _props3.data,
          className = _props3.className,
          preview = _props3.preview,
          measureRef = _props3.measureRef;

      var templateIsRTL = data && data.get('isRTL') || false;

      var _getScores2 = this.getScores(),
          scoreSubTitle = _getScores2.scoreSubTitle,
          scoreBody = _getScores2.scoreBody,
          scoreButtons = _getScores2.scoreButtons,
          flatScore = _getScores2.flatScore;

      var pctRound = Math.round(flatScore * 0.1) * 10;
      var image = data.get('image');

      return _react2.default.createElement(
        'div',
        { className: className, ref: measureRef },
        _react2.default.createElement(
          'div',
          { style: wseContentStyle, className: 'wsequiz_content' + (preview ? ' preview' : '') },
          image && (0, _RenderHelper.mountImage)(image, { width: this.props.viewWidth, height: this.props.viewHeight, crop: 'center' }),
          _react2.default.createElement(
            'div',
            { style: mainCfContainerStyle },
            this.mountMainText(data.get('texts')),
            this.mountMainButtons(data.get('buttons')),
            !data.get('hideImage') && _react2.default.createElement('img', { style: coursefinderImgStyle, className: 'coursefinder_progress',
              src: 'https://quiz.wsemktapp.com/progress/cf_' + (templateIsRTL ? 'rtl_' : '') + pctRound + '.png'
            }),
            this.mountScoreText(scoreSubTitle, scoreBody),
            this.mountScoreButtons(scoreButtons)
          )
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      return this.props.quizType === 'Quiz' ? this.renderQuiz() : this.renderCourseFinder();
    }
  }]);

  return RenderEmail;
}(_react.Component);

exports.default = RenderEmail;


//////////////////
// WEBPACK FOOTER
// ./node_modules/wse-quiz-component/lib/RenderEmail.js
// module id = 816
// module chunks = 0